import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from 'src/app/services/helper.service';

@Component({
  selector: 'app-card-event',
  templateUrl: './card-event.component.html',
  styleUrls: ['./card-event.component.scss']
})
export class CardEventComponent implements OnInit {
  @Input() id:        string        = '';
  @Input() image:     string        = '';
  @Input() imagePdv:  string        = '';
  @Input() name:      string        = '';
  @Input() showTime:  boolean       = true;
  @Input() address:   string        = '';
  @Input() state:     string        = '';
  @Input() utm?:      string        = '';
  @Input() city:      string        = '';
  @Input() uf:        string        = '';
  @Input() date:      string | null = '';
  @Input() redirectToExternalLink?: string = '';
  @Input() button:    boolean       = false;
  @Input() skeleton:  boolean       = false;
  @Input() slugs?:    any[];
  @Input() link?:     boolean       =  true;
  
  public customEvents = [
    "12e8e480-c1f3-4e42-b4fc-006c4913ca89",
    "e31c2e19-5c6c-46b5-be0b-26ab22ec7d1a",
    "034f7ecc-db4f-4043-8ce4-a911ad9c0ac7"
  ]
  
  constructor(
    private router: Router,
    private helperService: HelperService
  ) { }

  ngOnInit(): void {

  }

  public open(): void {
    if(this.redirectToExternalLink) {
      window.open(this.redirectToExternalLink, '_blank');
      return;
    }
    if (this.link == true) {
      if (this.slugs && this.slugs.length > 0) {
        if (this.utm != null && this.utm != "") {
          this.router.navigateByUrl(this.slugs[0].slug+"?"+this.utm);
        } else {
          this.router.navigateByUrl(this.slugs[0].slug);
        }
      } else {
        this.router.navigate(['/event', this.id]);
      }
    }
  }

}
